export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/color-picking.worker.df184a5e.worker.js");
}
